export enum ContractType {
  FIXED = 'FIXED',

  VARIABLE = 'VARIABLE',

  DYNAMIC = 'DYNAMIC',
}
